import { useEffect } from 'react';

const useFavicon = () => {
  useEffect(() => {
    // Créer le favicon TY dynamiquement
    const createFavicon = () => {
      const canvas = document.createElement('canvas');
      canvas.width = 32;
      canvas.height = 32;
      const ctx = canvas.getContext('2d');
      
      // Fond bleu avec gradient simulé
      ctx.fillStyle = '#2563eb';
      ctx.fillRect(0, 0, 32, 32);
      
      // Coins arrondis (approximation)
      ctx.globalCompositeOperation = 'destination-out';
      const cornerSize = 3;
      // Coins
      ctx.fillRect(0, 0, cornerSize, cornerSize);
      ctx.fillRect(32-cornerSize, 0, cornerSize, cornerSize);
      ctx.fillRect(0, 32-cornerSize, cornerSize, cornerSize);
      ctx.fillRect(32-cornerSize, 32-cornerSize, cornerSize, cornerSize);
      
      ctx.globalCompositeOperation = 'source-over';
      
      // Texte TY
      ctx.fillStyle = 'white';
      ctx.font = 'bold 12px Arial, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('TY', 16, 16);
      
      // Créer ou mettre à jour le favicon
      let favicon = document.querySelector('link[rel*="icon"]:not([rel*="apple"])');
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }
      
      favicon.type = 'image/png';
      favicon.href = canvas.toDataURL();
      
      console.log('✅ Favicon TY appliqué dynamiquement');
    };
    
    // Appliquer le favicon après un court délai pour s'assurer que le DOM est prêt
    const timer = setTimeout(createFavicon, 500);
    
    return () => clearTimeout(timer);
  }, []);
};

export default useFavicon;